import {
	DELETE_DEVICE,
	DEVICE_EDIT,
	DEVICE_ERRORS, DEVICE_MANAGE,
	ENABLE_DEVICE_MODULE,
	GO_TO_JASPER,
	REFRESH_DEVICE_INFO,
	REQUEST_APP_LOGS,
	RESET_DEVICE_POSITION,
	SHOW_INFO_DIALOG,
	UPDATE_DEVICE,
	DISCONNECT,
	ADMIN_DEVICE_BULK_ACTION, 
	DOWNLOAD_CNF,
	CUSTOM_CONFIGS_CHANGED,
	IMPORT_V4_DEVICES,
	V4_IMPORT_ROW_RESULT,
	V4_IMPORT_DONE,
	RESET_V4_IMPORT
} from './constants';

export const resetDevicePosition = device => ({ type: RESET_DEVICE_POSITION, device });
export const updateDevice = (device, smsServerConfig, replacing, v4Meta) => ({ type: UPDATE_DEVICE, device, smsServerConfig, replacing, v4Meta });
export const deleteDevice = device => ({ type: DELETE_DEVICE, device });
export const deviceError = errors => ({ type: DEVICE_ERRORS, errors });
export const setEditDevice = (device, replacing) => ({ type: DEVICE_EDIT, device, replacing });
export const setManageDevice = device => ({ type: DEVICE_MANAGE, device });
export const enableDeviceModule = (device, moduleId, isEnabled) => ({ type: ENABLE_DEVICE_MODULE, device, moduleId, isEnabled });
export const goToJasper = (device) => ({ type: GO_TO_JASPER, device});
export const showInfoDialog = (deviceId) => ({ type: SHOW_INFO_DIALOG, deviceId});
export const refreshDeviceInfo = deviceId => ({ type: REFRESH_DEVICE_INFO, deviceId});
export const requestAppLogs = deviceId => ({ type: REQUEST_APP_LOGS, deviceId});
export const disconnect = device => ({ type: DISCONNECT, device});
export const adminDeviceBulkAction = (deviceIds, actionResolver) => ({ type: ADMIN_DEVICE_BULK_ACTION, deviceIds, actionResolver });
export const downloadCnf = device => ({ type: DOWNLOAD_CNF, device });
export const customConfigsChanged = customConfigs => ({ type: CUSTOM_CONFIGS_CHANGED, customConfigs });
// rows: [{ id, ownerUuid, payload }]
export const importV4Devices = rows => ({ type: IMPORT_V4_DEVICES, rows });
// result: { status: 'created', uuid, ownerUuid } | { status: 'failed', error, field? } | null
export const v4ImportRowResult = (id, result) => ({ type: V4_IMPORT_ROW_RESULT, id, result });
export const v4ImportDone = () => ({ type: V4_IMPORT_DONE });
export const resetV4Import = () => ({ type: RESET_V4_IMPORT });

